import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { queryKey } from "../../enumerations/queryKey";
import { apiGetPortal } from "./service";

export const useGePortal = (options?: Omit<UseQueryOptions<string[]>, "queryKey" | "queryFn">) => {
  return useQuery<string[]>({
    queryKey: [queryKey.PORTAL],
    queryFn: () => apiGetPortal().then((res) => res.data.data),
    ...options,
  });
};
